// extracted by mini-css-extract-plugin
export default {"promptBox":"promptBox__BNRy5o0F","inputWrapper":"inputWrapper__an0KOyJA","textInput":"textInput__f9D2cHbD","submitButton":"submitButton__YlU4vokC"};